export default [
    {
        path: 'relatorio-visita-domiciliar',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-visita-domiciliar' */
            '@/views/atencao-basica/relatorio-visita-domiciliar/Index.vue'
        ),
        redirect: 'relatorio-visita-domiciliar/index',
        children: [
            {
                name: 'atencao-basica-relatorio-visita-domiciliar-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-visita-domiciliar' */
                    '@/views/atencao-basica/relatorio-visita-domiciliar/List.vue'
                ),
            },
        ],
    },
]